<template>



</template>

<script>
	export default {
		props: ['data'], 
		data() {
			return {

			};
		},
		mounted() {
		},
		methods: {

		},
	}
</script>       